module.exports = __webpack_public_path__ + "static/img/fullscreen-image_customize-your-theme-and-questions_768.972ea47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_customize-your-theme-and-questions_768.png
// module id = flTp
// module chunks = 0